import { render, staticRenderFns } from "./CardMessage.vue?vue&type=template&id=65ac7e35&scoped=true&lang=pug"
import script from "./CardMessage.vue?vue&type=script&lang=js"
export * from "./CardMessage.vue?vue&type=script&lang=js"
import style0 from "./CardMessage.vue?vue&type=style&index=0&id=65ac7e35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac7e35",
  null
  
)

export default component.exports